import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface HashedPasswordBrand {
    readonly HashedPassword: unique symbol;
}
export const HashedPassword = brand(
    NonEmptyString,
    (n): n is Branded<NonEmptyString, HashedPasswordBrand> => true,
    'HashedPassword'
);
export type HashedPassword = TypeOf<typeof HashedPassword>;
